module.exports = [
  {
    name: 'None',
    path: null,
    format: '.jpg'
  },
  {
    name: 'Park (Day)',
    path: 'assets/environment/Park2/',
    format: '.jpg'
  },
  {
    name: 'Park (Night)',
    path: 'assets/environment/Park3Med/',
    format: '.jpg'
  },
  {
    name: 'Bridge',
    path: 'assets/environment/Bridge2/',
    format: '.jpg'
  },
  {
    name: 'Sky',
    path: 'assets/environment/skybox/',
    format: '.jpg'
  },
  {
    name: 'Castle',
    path: 'assets/environment/SwedishRoyalCastle/',
    format: '.jpg'
  },
  {
    name: 'Footprint Court (HDR)',
    path: 'assets/environment/FootprintCourt/',
    format: '.hdr'
  }
];
